module.exports = __webpack_public_path__ + "static/media/bn.384df9d9.svg";